export const invoicesMisc = {
  sendLink: {
    title: "Envoyer le lien de facture",
    already: {
      title: "Cette réservation a déjà une facture émise.",
      onlyOne: "Seule <b>1 facture par réservation</b> est autorisée.",
      offerPdf:
        "Si vous le souhaitez, nous pouvons vous envoyer le PDF de la facture dès maintenant via WhatsApp.",
    },
    openPdf: "Ouvrir le PDF",
    sendWhatsapp: "Envoyer la facture via WhatsApp",
    sending: "Envoi...",
    info: {
      title: "Le lien de facture sera envoyé au client via WhatsApp.",
      desc: "Le client complétera ses informations fiscales depuis le lien et pourra télécharger sa facture électronique.",
    },
    rule: "<strong>Règle :</strong> seule <b>1 facture par réservation</b> peut être émise.",
    accept: "Accepter et envoyer",
    toast: {
      invoiceSent: "Facture envoyée via WhatsApp.",
      linkSent: "Lien de facture envoyé via WhatsApp.",
    },
    warn: {
      noReservation: "L'identifiant de la réservation n'a pas encore été trouvé.",
    },
    err: {
      sendInvoiceFailed: "La facture n'a pas pu être envoyée via WhatsApp.",
      sendLinkFailed: "Le lien n'a pas pu être envoyé.",
    },
  },
  country: {
    placeholder: "Sélectionner un pays (facultatif)",
    noResult: "Aucun résultat",
  },
  adjust: {
    title: "Ajuster {name}",
    type: {
      apartment: "Appartement(s)",
      hotel: "Hôtel (Chambres)",
      villa: "Villas",
      camping: "Emplacements de camping",
      default: "Hébergements",
    },
    usage: "Utilisation actuelle",
    available: "Disponible",
    unitDefault: "unités",
    hintReduce:
      "La réduction s'applique immédiatement et ne génère <b>aucun</b> remboursement. Vous paierez moins sur votre prochaine facture.",
    unitPriceCurrent: "Prix unitaire actuel",
    totalBeforeProration: "Total (avant proratisation)",
    prorationNote:
      "Une <b>proratisation</b> sera appliquée pour les jours écoulés dans le cycle.",
    confirmIncrease: "Confirmer l'augmentation",
    confirmDecrease: "Confirmer la réduction",
    err: {
      selectAmount: "Sélectionnez un montant à ajuster.",
      failed: "L'opération n'a pas pu être effectuée.",
    },
    toast: {
      added: "Unités ajoutées",
      reduced: "Unités réduites",
      addedDetail: "Une proratisation sera appliquée pour les jours restants du cycle.",
      reducedDetail: "Vous paierez moins sur votre prochaine facture (aucun remboursement).",
    },
  },
  menu: {
    title: "Mon abonnement",
    subtitle: "Gérez vos abonnements, factures et moyens de paiement",
    subscription: "Mon abonnement",
    paymentMethod: "Moyen de paiement",
    invoices: "Factures",
  },
  custom: {
    title: "Forfait personnalisé",
    whatDoYouNeed: "De quoi avez-vous besoin ?",
    salesContact:
      "Notre équipe commerciale vous contactera dès que possible.",
    tellUs: "Parlez-nous davantage de votre projet",
    sentOk: "Envoyé avec succès",
    salesContactShort:
      "L'équipe commerciale vous contactera dès que possible",
    contactSales: "Contacter l'équipe commerciale",
    err: {
      required:
        "Vous devez préciser ce dont vous avez besoin afin que nous puissions vous contacter",
      failed: "Désolé, la demande n'a pas pu être traitée",
    },
  },
  common: {
    cancel: "Annuler",
    close: "Fermer",
  },
};
